import { Schema as S } from "effect";
import { epochMillisOfUtcInstant, parseUtcInstant } from "@ascleo/types/date-time-validity";

const UtcScheduleInstant = S.String.pipe(
  S.check(S.makeFilter((value) => {
    try {
      parseUtcInstant(value);
      return true;
    } catch {
      return false;
    }
  }, { message: "Expected a valid UTC schedule instant" })),
);

/**
 * Decoded vendor schedule evidence shared by list and find ingress.
 *
 * @since 1.1.8
 * @example
 * ```ts
 * S.decodeUnknownResult(SchedulePayloadSchema)({
 *   _id: "schedule-1", calendar: "calendar-1",
 *   start: "2026-10-05T08:00:00.000Z", end: "2026-10-05T09:00:00.000Z",
 *   closeTime: true, closeDayType: "VACATION",
 * });
 * ```
 */
export const SchedulePayloadSchema = S.Struct({
  _id: S.String,
  start: UtcScheduleInstant,
  end: UtcScheduleInstant,
  calendar: S.String,
  lastEditedDate: S.optional(S.String),
  duration: S.optional(S.Number),
  plannedDuration: S.optional(S.Number),
  type: S.optional(S.String),
  adhoc: S.optional(S.Boolean),
  patient: S.optional(S.String),
  scheduled: S.optional(S.Number),
  allDay: S.optional(S.Boolean),
  closeTime: S.optional(S.Boolean),
  closeDayType: S.optional(S.Literals(["HOLIDAY", "VACATION", "OTHER"])),
  severity: S.optional(S.String),
  urgency: S.optional(S.Number),
  userDescr: S.optional(S.String),
  resource: S.optional(S.String),
  resourceBased: S.optional(S.Boolean),
  linkByResource: S.optional(S.String),
  title: S.optional(S.String),
  scheduletype: S.optional(S.String),
  employee: S.optional(S.String),
  arrivalTime: S.optional(S.String),
  creationDate: S.optional(S.String),
  isReadOnly: S.optional(S.Boolean),
  wasInTreatment: S.optional(S.Boolean),
  weekdays: S.optional(S.Array(S.Unknown)),
}).pipe(S.check(S.makeFilter((schedule) => epochMillisOfUtcInstant(schedule.end) > epochMillisOfUtcInstant(schedule.start), {
  message: "Schedule end must be after its start",
})));
